import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import "./sidepanel.css";
import Root from "./components/Root";
import ResultDetector from "./components/ResultDetector";
import ResultPlagiarism from "./components/ResultPlagiarism";
import { AppProvider } from "./context/AppProvider";
import { Toaster } from "./components/ui/sonner";

interface AppProps {
	selectedText?: string | null;
}

export const App = ({ selectedText }: AppProps) => {
	return (
		<AppProvider>
			<Router>
				<Routes>
					<Route path="/" element={<Root selectedText={selectedText} />} />
					<Route
						path="/plagiarism"
						element={<Root selectedText={selectedText} />}
					/>
					<Route path="/result_detector" element={<ResultDetector />} />
					<Route path="/result_plagiarism" element={<ResultPlagiarism />} />
					<Route path="*" element={<Navigate to="/" replace />} />
				</Routes>
			</Router>
			<Toaster richColors />
		</AppProvider>
	);
};
